export class TypeCategorySimple {
  id: number;
  title: string;
  key: string;
  display: string;
  section: number;
  ordering: number;
  hasChain: boolean;
}
